<div #scrollContainer class="flex flex-col grow overflow-y-auto px-4 py-4 gap-0" (scroll)="onScroll($event)">
  @if (messagesLoading()) {
    <app-ai-message-list-loading-skeleton />
  } @else if (messages().length === 0 && !isStreaming()) {
    @if (showSuggestions()) {
      <div class="flex flex-col items-start gap-1 mt-auto">
        <p class="text-xs text-foreground-primary-60 mb-2">{{ 'ai-assistant.suggestions.title' | translate }}</p>
        @for (suggestion of suggestions(); track suggestion) {
          @let suggestionText = suggestion | translate;
          <button
            type="button"
            class="text-left text-sm font-medium text-action-secondary dark:text-foreground-primary-100 bg-background-container-primary hover:bg-background-container-secondary rounded-radius-secondary px-2 py-2 transition-colors"
            (click)="onSuggestionClick(suggestionText)"
          >
            {{ suggestionText }}
          </button>
        }
      </div>
    }
  } @else {
    @for (message of messages(); track message.id; let i = $index) {
      <app-ai-message [message]="message" [showLeadingIcon]="i === 0 || messages()[i - 1].role !== 'assistant'" />
    }
    @if (showTypingIndicator()) {
      <div class="flex items-center gap-1.5 text-foreground-primary-40 py-2">
        <span class="inline-block w-2 h-2 rounded-full bg-foreground-primary-40 animate-bounce [animation-delay:0ms]"></span>
        <span class="inline-block w-2 h-2 rounded-full bg-foreground-primary-40 animate-bounce [animation-delay:150ms]"></span>
        <span class="inline-block w-2 h-2 rounded-full bg-foreground-primary-40 animate-bounce [animation-delay:300ms]"></span>
      </div>
    }
  }
</div>
